"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function isLogicalOr(op) {
  return !!op.or;
}

exports.isLogicalOr = isLogicalOr;

function isLogicalAnd(op) {
  return !!op.and;
}

exports.isLogicalAnd = isLogicalAnd;

function isLogicalNot(op) {
  return !!op.not;
}

exports.isLogicalNot = isLogicalNot;

function forEachLeaf(op, fn) {
  if (isLogicalNot(op)) {
    forEachLeaf(op.not, fn);
  } else if (isLogicalAnd(op)) {
    for (var _i = 0, _a = op.and; _i < _a.length; _i++) {
      var subop = _a[_i];
      forEachLeaf(subop, fn);
    }
  } else if (isLogicalOr(op)) {
    for (var _b = 0, _c = op.or; _b < _c.length; _b++) {
      var subop = _c[_b];
      forEachLeaf(subop, fn);
    }
  } else {
    fn(op);
  }
}

exports.forEachLeaf = forEachLeaf;

function normalizeLogicalOperand(op, normalizer) {
  if (isLogicalNot(op)) {
    return {
      not: normalizeLogicalOperand(op.not, normalizer)
    };
  } else if (isLogicalAnd(op)) {
    return {
      and: op.and.map(function (o) {
        return normalizeLogicalOperand(o, normalizer);
      })
    };
  } else if (isLogicalOr(op)) {
    return {
      or: op.or.map(function (o) {
        return normalizeLogicalOperand(o, normalizer);
      })
    };
  } else {
    return normalizer(op);
  }
}

exports.normalizeLogicalOperand = normalizeLogicalOperand;